module.exports = __webpack_public_path__ + "assets/01.5c6985d0.pdf";